import baseReport from '../baseReport';
import _ from 'lodash';
import { exists } from 'fs';
import { nextTick } from 'q';
import { isNull } from 'util';
import formatNumber from '../../plugins/filters/formatNumber';
import formatDataBR from '@/plugins/filters/formatDataBR';

const montarAssinatura = (professores) => {
  return [
    {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          alignment: 'right',
          layout: 'noBorders',
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: 'center',
                  fontSize: 8,
                  margin: [15, 35, 15, 0],
                  text: [
                    '_____________________________________________\n',
                    'Assinatura do Professor/Educador\n',
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ],
                }])),
            ],
          },
        },
        { width: '*', text: '' },
      ],
    },
  ];
};

const registroNotasAnalitico = async ({ date, time, filtros, cdpravadi, data, professores, tipoDeEnsino, indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Registro de Notas Consolidado'});

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [
        { text: 'Professor/Educador: ', bold: true },
        nameProfessores,
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: 'Ano letivo:  ', bold: true },
            filtros.aaletivo,
            ...AnoSubsquente
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Turma: ', bold: true },
            filtros.turma,
          ],
        },
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ? 'Campos de Experiência:   ' : 'Disciplina:   ', bold: true },
            filtros.disciplina,
          ],
        }
      ],
    },
  ];

  function criarEspaco(tamanho, text=null, array=null, ordem=null){
    let teste = [];
    for (let index = 1; index < tamanho; index++) {
      if(array)
        teste.push({width:text});
      else if(ordem)
        teste.push({text, ordem});
      else
        teste.push({text});
    }
    return teste;
  }


  function getOrdem(indicaatividade){
    switch (indicaatividade) {
      case 'N':
        return 1;
      case 'R':
        return 3;
      case 'E':
        return 5;
    }
  }

  function getNome(codigo){
    switch (codigo){
      case 'N':
        return 'Notas';
      case 'R':
        return 'Rec. do Período';
    }
  }


  const dados = data.alunos;
  var tabelas = [];
  var widths = [];
  var titulo = [];
  var subtitulo = []
  var notas = [];

  for (const i in dados[0].notas) {
    let ordem = dados[0].notas[i][0].ordem;
    ordem = (ordem)?ordem:1;
    let cols = (i == 'Oportunidades Finais')?dados[0].notas[i].length:((ordem == 1)? dados[0].notas[i].length: 0);
    titulo.push({text:i, ordem:ordem, colSpan: cols, alignment:'center', style:'tableHeader'}, ...criarEspaco(cols,null,null,ordem));
    for(const j in dados[0].notas[i]){
      let nome = (dados[0].notas[i][j].indicaatividade)?getNome(dados[0].notas[i][j].indicaatividade):'';
      nome = (nome)?nome:((dados[0].notas[i][j].dsatv)?dados[0].notas[i][j].dsatv:'');
      let ordem = dados[0].notas[i][j].ordem;
      ordem = (ordem)?ordem:1;
      subtitulo.push({text:nome, ordem:ordem, alignment:'center', style:'tableSubHeader'});
    }
  }
  for(const k in dados){
    let invalido = '';
    let fillColor = '';
    if((dados[k].invalido)){
      invalido = ` - ${dados[k].invalido}`;
      fillColor = '#FFDAB9';
    }

    if (dados[k].invalido === 'PDI') {
      notas.push([{text:`${dados[k].nmaluno}${invalido}\nDt Enturmação: ${formatDataBR(data.alunos[k].dtsitalun)} ${(data.alunos[k].dtafastam)? ` - ${formatDataBR(data.alunos[k].dtafastam)}` : ''}`, ordem:0,fillColor }])
    }
    else {
      notas.push([{text:`${dados[k].nmaluno} \nDt Enturmação: ${formatDataBR(data.alunos[k].dtsitalun)} ${invalido} ${(data.alunos[k].dtafastam)? ` - ${formatDataBR(data.alunos[k].dtafastam)}` : ''}`, ordem:0,fillColor }])
    }



    for (const l in dados[k].notas) {
      for(const m in dados[k].notas[l]){
        let ordem = dados[k].notas[l][m].ordem;
        ordem = (ordem)?ordem:1;
        let nota = dados[k].notas[l][m].nota;
        if(ordem != 5)
          nota = (!isNull(nota))?formatNumber(parseFloat(nota)):'-';

        notas[k].push({text:nota, ordem:ordem, alignment:'center'});
      }
    }
    notas[k] = _.sortBy(notas[k],'ordem');


  }
  titulo.unshift({text:'Período Avaliativo ->', ordem: 0, alignment:'center', style:'tableHeader'});
  titulo = _.sortBy(titulo,'ordem');
  subtitulo.unshift({text:'Alunos', ordem:0, alignment:'center', style:'tableSubHeader'});
  subtitulo = _.sortBy(subtitulo,'ordem');

  widths.push({width:'*'}, ...criarEspaco(subtitulo.length, 'auto', true));
  tabelas.push({
    margin: [0, 17, 0, 0],
    fontSize: 7,
    table: {
      widths: widths,
      body: [
        titulo,
        subtitulo,
        ...notas,
      ]
    },layout: {
      defaultBorder: true,
    }
  });

  const dataFormated = [tabelas];

  return {
    ...headerFooter,
    pageOrientation: 'landscape',
    pageSize: 'A4',
    content: [
      ...filtrosFormated,
      ...dataFormated,
      ...montarAssinatura(professores),
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee'
      },
      tableSubHeader: {
        bold: true,
        fontSize: 7,
        color: 'black',
        fillColor: '#D3D3D3'
      }
    },
  };
};

export default registroNotasAnalitico;
